import Config from './Config';

export function loadGoogleMaps() {
    const googleMaps = document.createElement('script');
    googleMaps.src = `https://maps.googleapis.com/maps/api/js?key=${Config.google_maps_key}&callback=initGoogleMaps`;
    googleMaps.defer = true;

    document.head.appendChild(googleMaps);
}
